<template>

  <div >

    <!-- <b-jumbotron header="以人为本，服务至上" lead="烟台市锐易电子技术有限公司" text-variant="center" class="" style="margin-top:0px;margin-bottom:10px;">

           </b-jumbotron> -->
  </div>
</template>
<script>
export default {
  name: 'MyJumbotron',
  data() {
    return {
      slide: 0,
      sliding: null
    }
  },
  methods: {
    onSlideStart(slide) {
      this.sliding = true
    },
    onSlideEnd(slide) {
      this.sliding = false
    }
  }
}
</script>
